document.addEventListener('DOMContentLoaded', () => {
  const attachBannerLinks = () => {
    const banners = document.querySelectorAll('[data-banner-container]');

    banners.forEach((banner) => {
      if (banner.dataset.bannerLinkBound === 'true') {
        return;
      }

      const overlayLink = banner.querySelector('.banner__overlay-link');
      if (!overlayLink) {
        return;
      }

      banner.dataset.bannerLinkBound = 'true';

      banner.addEventListener('click', (event) => {
        const interactiveTarget = event.target.closest('a, button, [role="button"], input, textarea, select');
        if (interactiveTarget) {
          return;
        }

        overlayLink.click();
      });
    });
  };

  attachBannerLinks();

  document.addEventListener('shopify:section:load', attachBannerLinks);
  document.addEventListener('shopify:section:select', attachBannerLinks);
});

